import { useSitecoreContext as c } from "@sitecore-jss/sitecore-jss-nextjs";
import { S as e, M as o } from "./use-sitecore-context.constants.CgDpyGY9.js";
const u = () => {
  const { sitecoreContext: r, updateSitecoreContext: i } = c(), s = (n) => {
    const { siteAttributes: C, ...a } = n;
    i(a);
  }, t = r;
  return t.siteAttributes = {
    isHospital: t.siteType === e.Hospital,
    isCorporate: t.siteType === e.Corporate,
    isMarket: t.marketContext === o.Market,
    isLocation: t.marketContext === o.Location,
    isPractice: t.marketContext === o.Practice,
    isUrgentCare: t.siteType === e.UrgentCare
  }, {
    sitecoreContext: t,
    updateSitecoreContext: s
  };
};
export {
  u
};
